<template>
  <v-tooltip bottom>
    <span v-if="displayWithTax" slot="activator" class="iprice">{{totalAmount | toCurrency(lang, currCode) }}</span>
    <span v-else slot="activator" class="iprice">{{totalNetAmount | toCurrency(lang, currCode) }}</span>
    <span>{{totalAmount | toCurrency(lang, currCode) }}</span><br>
    <span>ex. Tax: {{totalNetAmount | toCurrency(lang, currCode) }}</span>
  </v-tooltip>
</template>
<script>
/**
 * DisplayAmount.vue
 * Used to show the amount either with or without tax based on the
 * users choice in settings
 *
 * It also shows a tooltip showing both with and without tax totals
 *
 * Requires two props one for each total, the rest of the data
 * is pulled from the Store at a global level
 */
export default {
  name: 'DisplayAmount',
  props: {
    totalAmount: {
      type: [String, Number],
      required: true
    },
    totalNetAmount: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      displayWithTax: this.$store.getters.group.displayWithTax || false
    }
  }
}
</script>
